import { Grid, Stack } from "@mui/material";
import TopSection from "../../../Components/Common/Top/TopSection";
import MFMaterialConfig from "./MFMaterialConfig";

function MFCustomConfiguration() {
  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection
              labelList={[
                { title: "Home", path: "/bmf-custom-configuration" },
                { title: "Mapping Configuration" },
              ]}
              title="Market Forecast Custom Configuration"
            />
            <div class="container">
                <MFMaterialConfig />
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
}
export default MFCustomConfiguration
